import { Controller } from '@hotwired/stimulus';

// Holds the submit button back until the code is complete. Numeric codes are cleaned as typed;
// a backup code keeps its xxxxx-xxxxx dash and only the letters and digits are counted.
export default class extends Controller {
  static targets = ['code', 'submit']
  static values = { length: { type: Number, default: 6 }, numeric: { type: Boolean, default: true } }

  connect() {
    this.validate();
  }

  validate() {
    let entered;
    if (this.numericValue) {
      entered = this.codeTarget.value.replace(/\D/g, '').slice(0, this.lengthValue);
      this.codeTarget.value = entered;
    } else {
      entered = this.codeTarget.value.replace(/[^a-z0-9]/gi, '');
    }
    this.submitTarget.disabled = entered.length !== this.lengthValue;
  }
}
